import React, { Component } from 'react';
import Button from '../../components/Button/Button';
import { connect } from 'react-redux';
import './CreateAccountHeader.scss';
import { manageMyAccount } from '../../settings/links.json';

export class CreateAccountHeader extends Component {
    headerButtonClick() {
        window.open(
            this.props.app.deploy.env ? manageMyAccount[this.props.app.deploy.env] : '',
            '_blank'
        );
    }
    render() {
        return (
            <div className="header-format">
                <p className="create-account-text">Create a Safeco online account now!</p>
                <Button
                    text="Create account"
                    isUpperCase={false}
                    type="primary"
                    onClick={() => this.headerButtonClick()}
                    data-heap="create-account-button"
                    datacy="create-account-primary"
                />
            </div>
        );
    }
}
export function mapStoreToProps(store) {
    return {
        app: store.app
    };
}

export default connect(mapStoreToProps)(CreateAccountHeader);



// WEBPACK FOOTER //
// ./src/containers/CreateAccountHeader/CreateAccountHeader.jsx